import ReactGA from 'react-ga4';

import { GetTN } from '../Util/ShiurTN';
import { GetCM } from '../Util/ShiurCM';
import { GetTH } from '../Util/ShiurTH';
import { GetR1 } from '../Util/ShiurR1';
import { GetR3 } from '../Util/ShiurR3';
import { GetSM } from '../Util/ShiurSM';
import { GetHY } from '../Util/ShiurHY';
import { GetTF } from '../Util/ShiurTF';
import { GetEH } from '../Util/ShiurEH';
import { GetSH } from '../Util/ShiurSH';
import { GetHM } from '../Util/ShiurHM';
import { GetHZ } from '../Util/ShiurHZ';
import { GetBM } from '../Util/ShiurBM';
import { GetBZ } from '../Util/ShiurBZ';
import { GetBH } from '../Util/ShiurBH';
import { GetKS } from '../Util/ShiurKS';
import { GetAR } from '../Util/ShiurAR';
import { GetSO } from '../Util/ShiurSO';
import { GetMN } from '../Util/ShiurMN';
import { GetPN } from '../Util/ShiurPN';
import { GetBE } from '../Util/ShiurBE';


var Shiurim = {
	GetShiur: async function (type, date) {
		return this["GetShiur"+type.toUpperCase()](date);
	},

	GetShiurCM: async function (date) {
		return GetCM(date)
	},
	GetShiurTH: async function (date) {
		return GetTH(date);
	},
	GetShiurTN: async function (date) {
		return GetTN(date);
	},
	GetShiurR1: async function (date) {
		return GetR1(date);
	},
	GetShiurR3: async function (date) {
		return GetR3(date);
	},
	GetShiurSM: async function (date) {
		return GetSM(date);
	},
	GetShiurHY: async function (date) {
		return GetHY(date);
	},
	GetShiurTF: async function() {
		return GetTF();
	},
	GetShiurEH: async function() {
		return GetEH();
	},
	GetShiurSH: async function() {
		return GetSH();
	},
	GetShiurHM: async function() {
		return GetHM();
	},
	GetShiurHZ: async function() {
		return GetHZ();
	},
	GetShiurBM: async function (date) {
		return GetBM(date);
	},
	GetShiurBZ: async function (date) {
		return GetBZ(date);
	},
	GetShiurBH: async function (date) {
		return GetBH(date);
	},
	GetShiurKS: async function (date) {
		return GetKS(date);
	},
	GetShiurAR: async function (date) {
		return GetAR(date);
	},
	GetShiurMN: async function (date) {
		return GetMN(date);
	},
	GetShiurSO: async function (date) {
		return GetSO(date);
	},
	GetShiurPN: async function (date) {
		return GetPN(date);
	},
	GetShiurBE: async function (date) {
		return GetBE(date);
	}
};

export async function GetShiur(type, date) {
	ReactGA.event({ category: 'User', action: 'Shiur ' + type});
	return await Shiurim.GetShiur(type, date);
};
